module.exports = __webpack_public_path__ + "static/media/cachureos.4deccf73.webp";